(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("dayjs"), require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["dayjs", "React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["Guang"] = factory(require("dayjs"), require("React"), require("ReactDOM"));
	else
		root["Guang"] = factory(root["dayjs"], root["React"], root["ReactDOM"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_dayjs__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) => {
return 